import React from 'react';

import { ElementCard } from '@containers/OperatorSite/Operator/DetailOperator/detailOperatorStyle';

import { OPTION_ADD, USAGE_PLAN } from 'constants/constants';
import { ICompany, IDirectDebitSubCompany, IFile } from 'constants/operatorSite';
import { CardItem, CardItemFullWidth, SpaceBase } from 'styles';
import { CONST_LIST_COMPANY, CONST_CREATE_COMPANY, CONST_COMPANY_DEBIT } from 'constants/language';
import { stringToPhoneView, phoneStringToNumber } from 'helper/formatPhone';
import { BrokeragFeeLabel, DebitCardItem, TitleWrapper, WrapperBrokeragEFee, WrapperDebitSubCompany, WrapperFile, DirectDebitSubCompanyWrapper } from './CompanyStyle';
import { FileItem } from '@containers/OperatorSite/Company/DetailCompany/FileItem/FileItem';
import { formatDateJP } from 'helper/date';
import styled from 'styled-components';

interface IConfirmCreate {
  companyData: ICompany;
  agency: string;
  files: IFile[];
  directDebitSubCompanies: IDirectDebitSubCompany[];
}
export const WrapperList = styled.div`
  display: flex;
  flex-direction: column;
`;
export const WrapperOption = styled.div`
  display: flex;
  width: 100%
  flex-direction: row;
  font-size: 1.25rem;
  padding-right: 1rem;
  padding-top: 0.313rem;
  padding-left: 0px !important;
  word-break: break-all;
  .company-charge {
    margin-left: 1.5rem;
  }
`;

const ConfirmCreate = ({ companyData, agency, files, directDebitSubCompanies }: IConfirmCreate) => {
  return (
    <>
      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_LIST_COMPANY.COMPANY_NAME}</div>
        <ElementCard>{companyData.companyName}</ElementCard>
      </CardItem>

      <CardItem paddingHoz="0.75rem 0">
        <div>{CONST_CREATE_COMPANY.POSTAL_CODE}</div>
        <ElementCard>{`${companyData.postalCodeFirst && `${companyData.postalCodeFirst} - ${companyData.postalCodeEnd}`
          }`}</ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_CREATE_COMPANY.ADDRESS_FIRST}</div>
        <ElementCard>{companyData.address1}</ElementCard>
        <ElementCard width="14rem">{CONST_CREATE_COMPANY.ADDRESS_SECOND}</ElementCard>
        <ElementCard>{companyData.address2}</ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_LIST_COMPANY.REPRESENTATIVE_NAME}</div>
        <ElementCard>{companyData.fullName}</ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_LIST_COMPANY.PHONE_NUMBER}</div>
        <ElementCard>{stringToPhoneView(phoneStringToNumber(companyData.phoneNumber))}</ElementCard>
        <ElementCard width="14rem">{CONST_LIST_COMPANY.EMAIL_ADDRESS}</ElementCard>
        <ElementCard>{companyData.email}</ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_CREATE_COMPANY.FEE_FREE_DATE}</div>
        <ElementCard width={'67.875rem'}>
          {companyData?.freeStartDate ? formatDateJP(companyData.freeStartDate.format('YYYY-MM-DD')) : ''}
          <span className="space">{(companyData?.freeStartDate || companyData?.freeEndDate) && '〜'}</span>
          {companyData?.freeEndDate ? formatDateJP(companyData.freeEndDate.format('YYYY-MM-DD')) : ''}
        </ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_LIST_COMPANY.USAGE_PLAN}</div>
        <ElementCard>{USAGE_PLAN[Number(companyData.deposit) - 1].label}</ElementCard>
        <ElementCard width="14rem">{CONST_CREATE_COMPANY.USAGE_SITUATION}</ElementCard>
        <ElementCard>{CONST_CREATE_COMPANY.UNDER_REVIEW}</ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_CREATE_COMPANY.FEE}</div>
        <ElementCard>
          {companyData.fee}
          <span className="company-fee">{companyData.fee ? '円' : ''}</span>
        </ElementCard>
      </CardItem>

      <CardItem lineBottom={true} paddingHoz="0.75rem 0">
        <div>{CONST_CREATE_COMPANY.ADDITION_OPTIONS}</div>
        <WrapperList>
          {companyData.companyOptions?.map((option: any, index: number) => {
            return (
              <WrapperOption>
                {option.type && OPTION_ADD?.find(opt => opt.value === option.type)?.label}
                {option?.charge && (
                  <>
                    <span className="company-charge">{option.charge}</span>
                    <span>{'円'}</span>
                  </>
                )}
              </WrapperOption>
            );
          })}
        </WrapperList>
      </CardItem>

      <CardItem paddingHoz="0.75rem 0">
        <div>{CONST_LIST_COMPANY.AGENCY_CODE}</div>
        <ElementCard>
          {agency}
          {agency && `(${companyData.agencyCode})`}
        </ElementCard>
        <ElementCard width="14rem">
          <WrapperBrokeragEFee>
            <BrokeragFeeLabel>{CONST_CREATE_COMPANY.BROKERAGE__FEE_TOP}</BrokeragFeeLabel>
            <div>{CONST_CREATE_COMPANY.BROKERAGE__PRE_CASE}</div>
          </WrapperBrokeragEFee>
        </ElementCard>
        <ElementCard>{companyData.brokerageFee && `${companyData.brokerageFee}${CONST_LIST_COMPANY.YEN}`}</ElementCard>
      </CardItem>
      <CardItemFullWidth lineBottom={true} paddingHoz="0.625rem 0">
        <TitleWrapper>
          <div>{CONST_LIST_COMPANY.DOCUMENTS}</div>
          <div />
        </TitleWrapper>
        <SpaceBase height={1} />
        <WrapperFile>
          {files?.map((element: IFile) => {
            const dataFile: any = document?.getElementById(`element_${element.id}`);
            return (
              <React.Fragment key={element.id}>
                <FileItem
                  name={dataFile?.value || ''}
                  status={element.status}
                  fromConfirm={true}
                  documentId={element.id}
                />
              </React.Fragment>
            );
          })}
        </WrapperFile>
      </CardItemFullWidth>
      <CardItemFullWidth lineBottom={true} paddingHoz="0.625rem 0">
        <DebitCardItem>
          <div>{CONST_COMPANY_DEBIT.SETTING_GROUP}</div>
        </DebitCardItem>
        <DebitCardItem>
          <div>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_ENABLE}</div>
          <ElementCard>
            {companyData.directDebitEnabled ? CONST_COMPANY_DEBIT.ENABLE : CONST_COMPANY_DEBIT.DISABLE}
          </ElementCard>
        </DebitCardItem>
        <DebitCardItem>
          <div>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_START_MONTH}</div>
          <ElementCard>
            {companyData.directDebitStartMonth ? formatDateJP(companyData.directDebitStartMonth.format('YYYY-MM'), false) : ''}
          </ElementCard>
        </DebitCardItem>
        <DebitCardItem>
          <div>{CONST_COMPANY_DEBIT.CUSTOMER_ID}</div>
          <ElementCard>{companyData.directDebitAccountNumber}</ElementCard>
        </DebitCardItem>
        <DebitCardItem>
          <div>{CONST_COMPANY_DEBIT.INVOICE_NUMBER}</div>
          <ElementCard>{companyData.directDebitInvoiceNumber}</ElementCard>
        </DebitCardItem>
        <DebitCardItem>
          <div style={{ width: '12rem' }}>{CONST_COMPANY_DEBIT.SUB_COMPANY}</div>
          <div style={{ width: '100%' }}>
            <DirectDebitSubCompanyWrapper>
              {directDebitSubCompanies?.map((element: IDirectDebitSubCompany, index: number) => (
                <WrapperOption>
                  {element.name}
                </WrapperOption>
              ))}
            </DirectDebitSubCompanyWrapper>
          </div>
        </DebitCardItem>
      </CardItemFullWidth>
    </>
  );
};

export default ConfirmCreate;
